import Stack from '@mui/material/Stack';
import { pxToRem } from '../../../utils/pxToRem';
import { conventionContent } from '../content';
import { NavLink } from './NavLink';

export interface TopNavProps {
  activeTargetId?: string;
}

export function TopNav({ activeTargetId }: TopNavProps) {
  const { nav } = conventionContent;
  return (
    <Stack
      component="nav"
      aria-label={nav.label}
      direction="row"
      gap={pxToRem(24)}
      sx={{
        width: '100%',
        justifyContent: 'center',
        alignItems: 'flex-start',
        paddingTop: pxToRem(16),
        paddingBottom: pxToRem(14),
      }}
    >
      {nav.items.map((item, index) => (
        <NavLink
          key={`${item.targetId}-${item.label}-${index}`}
          href={`#${item.targetId}`}
          label={item.label}
          active={activeTargetId === item.targetId}
        />
      ))}
    </Stack>
  );
}
